import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const colorMap: Record<string, string> = {
    primary: 'bg-primary-500 text-background-50',
    accent: 'bg-accent-500 text-background-50',
    secondary: 'bg-secondary-500 text-background-50',
  };

  const iconBgMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-600',
    accent: 'bg-accent-100 text-accent-600',
    secondary: 'bg-secondary-100 text-secondary-600',
  };

  return (
    <section id="categories" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">
            探索历史事件分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            按不同领域浏览重大历史事件，深入了解每一个改变世界的时刻
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="bg-background-100 rounded-lg p-5 hover:bg-background-200/70 transition-colors no-underline group"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${iconBgMap[cat.color] || iconBgMap.primary}`}>
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1.5 whitespace-nowrap group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}